// Referrals.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import { url } from "../Api/config";

const Referrals = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedUser, setSelectedUser] = useState(null);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const formData = new FormData();
                const res = await axios.post(`${url}/api/getuserswithreferrals`, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
                if (res.data && res.data.res && res.data.users) {
                    setUsers(res.data.users);
                } else {
                    setUsers([]);
                }
            } catch (err) {
                console.error("Ошибка при загрузке пользователей с рефералами:", err);
                setUsers([]);
            } finally {
                setLoading(false);
            }
        };
        fetchUsers();
    }, []);

    const handleUserClick = (user) => {
        setSelectedUser(user);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedUser(null);
    };

    if (loading) return <p>Загрузка пользователей...</p>;

    return (
        <>
            <div style={{ padding: "20px", maxHeight: "600px", overflowY: "auto", border: "1px solid #ccc" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <label style={{ fontSize: '12px' }}>Пользователей с рефералами: ({users.length})</label>
                </div>

                {users.length === 0 ? (
                    <p>Нет пользователей с рефералами</p>
                ) : (
                    <table
                        style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            backgroundColor: "#f7f7f7",
                        }}
                    >
                        <thead
                            style={{
                                position: "sticky",
                                top: 0,
                                backgroundColor: "#e0e0e0",
                                zIndex: 2,
                            }}
                        >
                            <tr>
                                <th style={thStyle}>№</th>
                                <th style={thStyle}>ID</th>
                                <th style={thStyle}>Email</th>
                                <th style={thStyle}>Имя</th>
                                <th style={thStyle}>Фамилия</th>
                                <th style={thStyle}>Адрес</th>
                                <th style={thStyle}>Компания</th>
                                <th style={thStyle}>Кол-во рефералов</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.map((user, index) => (
                                <tr
                                    key={user.user_id}
                                    style={{
                                        ...trStyle,
                                        cursor: "pointer",
                                    }}
                                    onClick={() => handleUserClick(user)}
                                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#e8f4f8")}
                                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fafafa")}
                                >
                                    <td style={{ ...tdStyle, color: "green" }}>{index + 1}</td>
                                    <td style={tdStyle}>{user.user_id}</td>
                                    <td style={tdStyle}>{user.email || "—"}</td>
                                    <td style={tdStyle}>{user.name || "—"}</td>
                                    <td style={tdStyle}>{user.surname || "—"}</td>
                                    <td style={tdStyle}>{user.country || "—"}</td>
                                    <td style={tdStyle}>{user.company || user.company_name || "—"}</td>
                                    <td style={{ ...tdStyle, fontWeight: "bold", color: "#007bff" }}>
                                        {user.referrals_count || 0}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

            {/* Модальное окно с рефералами */}
            {showModal && selectedUser && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1000,
                    }}
                    onClick={closeModal}
                >
                    <div
                        style={{
                            backgroundColor: "#fff",
                            padding: "20px",
                            borderRadius: "8px",
                            maxWidth: "800px",
                            width: "90%",
                            maxHeight: "80vh",
                            overflowY: "auto",
                            position: "relative",
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "20px",
                                borderBottom: "1px solid #ccc",
                                paddingBottom: "10px",
                            }}
                        >
                            <div>
                                <h3 style={{ margin: "0 0 5px 0" }}>
                                    Рефералы пользователя: {selectedUser.surname} {selectedUser.name} ({selectedUser.email})
                                </h3>
                                {selectedUser.referrals && selectedUser.referrals.length > 0 && (
                                    <div style={{ fontSize: "14px", color: "#666" }}>
                                        Общая сумма покупок всех рефералов:{" "}
                                        <span style={{ fontWeight: "bold", color: "#28a745" }}>
                                            {new Intl.NumberFormat('ru-RU', { 
                                                style: 'currency', 
                                                currency: 'RUB',
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0
                                            }).format(
                                                selectedUser.referrals.reduce((sum, ref) => sum + (Number(ref.amount) || 0), 0)
                                            )}
                                        </span>
                                    </div>
                                )}
                            </div>
                            <button
                                onClick={closeModal}
                                style={{
                                    background: "none",
                                    border: "none",
                                    fontSize: "24px",
                                    cursor: "pointer",
                                    color: "#666",
                                }}
                            >
                                ×
                            </button>
                        </div>

                        {selectedUser.referrals && selectedUser.referrals.length > 0 ? (
                            <div style={{ overflowX: "auto" }}>
                                <table
                                    style={{
                                        width: "100%",
                                        borderCollapse: "collapse",
                                        backgroundColor: "#f7f7f7",
                                    }}
                                >
                                    <thead
                                        style={{
                                            backgroundColor: "#e0e0e0",
                                        }}
                                    >
                                        <tr>
                                            <th style={modalThStyle}>№</th>
                                            <th style={modalThStyle}>ID</th>
                                            <th style={modalThStyle}>Email</th>
                                            <th style={modalThStyle}>Имя</th>
                                            <th style={modalThStyle}>Фамилия</th>
                                            <th style={modalThStyle}>Адрес</th>
                                            <th style={modalThStyle}>Компания</th>
                                            <th style={modalThStyle}>Сумма покупок</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedUser.referrals.map((referral, index) => {
                                            const amount = referral.amount || 0;
                                            const formattedAmount = amount > 0 
                                                ? new Intl.NumberFormat('ru-RU', { 
                                                    style: 'currency', 
                                                    currency: 'RUB',
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 0
                                                }).format(amount)
                                                : "—";
                                            
                                            return (
                                                <tr key={referral.user_id} style={trStyle}>
                                                    <td style={{ ...tdStyle, color: "green" }}>{index + 1}</td>
                                                    <td style={tdStyle}>{referral.user_id}</td>
                                                    <td style={tdStyle}>{referral.email || "—"}</td>
                                                    <td style={tdStyle}>{referral.name || "—"}</td>
                                                    <td style={tdStyle}>{referral.surname || "—"}</td>
                                                    <td style={tdStyle}>{referral.country || "—"}</td>
                                                    <td style={tdStyle}>{referral.company || "—"}</td>
                                                    <td style={{ ...tdStyle, fontWeight: amount > 0 ? "600" : "normal", color: amount > 0 ? "#28a745" : "#555" }}>
                                                        {formattedAmount}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <p>У этого пользователя нет рефералов</p>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

// стили для таблицы
const thStyle = {
    padding: "10px",
    textAlign: "left",
    borderBottom: "1px solid #ccc",
};

const modalThStyle = {
    padding: "10px",
    textAlign: "left",
    borderBottom: "1px solid #ccc",
};

const tdStyle = {
    padding: "8px",
    borderBottom: "1px solid #ddd",
};

const trStyle = {
    backgroundColor: "#fafafa",
};

export default Referrals;

